"use client";

import {createContext, useContext, useMemo, useState} from "react";
import {Locale} from "~/i18n-config";

export const dynamic = "force-dynamic";

interface ClientLocaleContextProps {
    readonly locale: Locale | undefined;
}

const ClientLocaleContext = createContext<ClientLocaleContextProps>({
    locale: undefined,
});

export const ClientLocaleProvider = ({ locale, children } : { locale: Locale, children: React.ReactNode }) => {

    const [currentLocale, setCurrentLocale] = useState<Locale | undefined>(locale);

    const value = useMemo(() => {
        return {
            locale: currentLocale,
        };
    }, [locale]);

    return (
        <ClientLocaleContext.Provider value={value}>
            {children}
        </ClientLocaleContext.Provider>
    );

}

export const useClientLocale = () => {
    const context = useContext(ClientLocaleContext);
    if (context === undefined) {
        throw new Error('useClientLocale must be used within an ClientLocaleProvider.');
    }
    return context;
};